/* COMPONENT IMPORTS*/
import authentication from "../../msalb2creact";
import ContextConstructor from "../Context/Context";

/* MODULE IMPORTS */
import { NavLink } from "react-router-dom";
import React, { Component } from "react";

/* CSS IMPORT */
import "./Sidebar.css";
import avatarDefault from "../../images/Avatar_default.png";

import bulletHomeImg from "../../images/side_bar/MyMontepio.svg";
import bulletPoupancaImg from "../../images/side_bar/poupancas.svg";
import bulletProtecaoImg from "../../images/side_bar/protecao.svg";
import bulletBeneficiosImg from "../../images/side_bar/beneficios.svg";
import bulletModalImg from "../../images/side_bar/modalidades.svg";
import close_menu from "../../images/close_menu.png";
import open_menu from "../../images/open_menu.png";
import protecao_poupanca from "../../images/protecao-poupanca.svg"


class DesktopSidebar extends Component {
  static displayName = DesktopSidebar.name;

  constructor(props) {
    super(props);
    this.state = {
      isSubMenuOpen: false
    }

  }

  addDefaultSrc(ev) {
    ev.target.src = avatarDefault;
  }

  openPopupGestor() {
    //faz triger do click para abrir o popup pretendido
    document.getElementById("popupGestorTrigger").click();
  }

  render() {

    var isElectionsTime = this.context.isElectionsTime;
    const { isCollapsed, toggleSidebar } = this.props;

    return (
      <>
        <nav className={`sidebar ${isCollapsed ? 'collapsed' : 'expanded'}`}>
          <div
            className={
              this.context.selectedUser.associateState ==
                "CONDICIONADO"
                ? "sidebar-list disabled-link"
                : "sidebar-list"
            }>
            <ul className="sidebar-links">
              <li>
                <NavLink exact activeClassName="active" className="link card" to="/"
                  onClick={(event) => {
                    window.history.replaceState(null, "", "/");
                  }}>
                  <img
                    src={bulletHomeImg}
                    alt=""
                    height="24px"
                    width="24px"></img>
                  <span className="item_label" style={{ marginLeft: "1em" }}> Montepio</span>
                </NavLink>
              </li>
              <li>
                <NavLink exact activeClassName="active" className="link card" to="/beneficios"
                  onClick={(event) => {
                    window.history.replaceState(null, "", "/beneficios");
                  }}>
                  <img
                    src={bulletBeneficiosImg}
                    alt=""
                    height="24px"
                    width="24px"></img>
                  <span className="item_label" style={{ marginLeft: "1em" }}>Benefícios</span>
                </NavLink>
              </li>
              <li>
                <div
                  className="link card disabled"
                  onClick={() => this.setState({ isSubMenuOpen: !this.state.isSubMenuOpen })}>
                  <img src={bulletModalImg} alt="" height="24px" width="24px" />
                  <span className="item_label" style={{ marginLeft: "1em" }}>Modalidades</span>
                </div>
              </li>
              <li>
                <NavLink exact activeClassName="active" className="link" to="/poupanca"
                  onClick={(event) => {
                    window.history.replaceState(null, "", "/poupanca");
                  }}>
                  <img
                    src={bulletPoupancaImg}
                    alt=""
                    height="24px"
                    width="24px"></img>
                  <span className="item_label" style={{ marginLeft: "1em" }}>Poupança</span>
                </NavLink>
              </li>
              <li>
                <NavLink exact activeClassName="active" className="link" to="/protecao"
                  onClick={(event) => {
                    window.history.replaceState(null, "", "/protecao");
                  }}>
                  <img
                    src={bulletProtecaoImg}
                    alt=""
                    height="24px"
                    width="24px"></img>
                  <span className="item_label" style={{ marginLeft: "1em" }}>Proteção</span>
                </NavLink>
              </li>
              <li>
                <NavLink exact activeClassName="active" className="link" to="/protecao_poupanca"
                  onClick={(event) => {
                    window.history.replaceState(null, "", "/protecao_poupanca");
                  }}>
                  <img
                    src={protecao_poupanca}
                    alt=""
                    height="24px"
                    width="24px"></img>
                  <span className="item_label" style={{ marginLeft: "1em" }}>Poupança + Proteção</span>
                </NavLink>
              </li>
            </ul>
          </div>
          <button className="collapse-btn" onClick={() => toggleSidebar()}>
            {isCollapsed ? <img
              src={open_menu}
              alt=""
              height="24px"
              width="24px" />
              : <img
                src={close_menu}
                alt=""
                height="24px"
                width="24px" />
            }
          </button>
        </nav >
      </ >
    );
  }
}

DesktopSidebar.contextType = ContextConstructor;

export default DesktopSidebar;
